import React from 'react';

class Notification extends React.Component {
  componentWillMount() {
    setTimeout(this.dismiss, 10000);
  }

  dismiss = () => {
    const { id, dismiss } = this.props;
    dismiss(id);
  };

  render() {
    const { message, error } = this.props;
    return (
      <div className={`notification bg-midnight-gray position-relative ${error ? 'danger' : ''}`}>
        <span className="bell">
          <i className="fa fa-bell" />
        </span>
        <button
          type="button"
          className="close"
          aria-label="Close"
          onClick={this.dismiss}
        />
        <div className="message t-light">
          <p className="t4 mb-1">{message}</p>
        </div>
      </div>
    );
  }
}

export default Notification;
